import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CONTROL_DE_GRADO } from '../../../../config/tables'

export default function ControlDeGradoView () {
  return <MuiTable id={TABLA_CONTROL_DE_GRADO} />
}
